// extracted by mini-css-extract-plugin
export var avatarContainer = "_6z-0";
export var avatarTypingWave = "_6z-i";
export var gray = "_6z-f";
export var green = "_6z-c";
export var icon = "_6z-9";
export var image = "_6z-1";
export var lg = "_6z-6";
export var md = "_6z-5";
export var presenceDot = "_6z-b";
export var red = "_6z-d";
export var sm = "_6z-4";
export var status = "_6z-a";
export var typingDot = "_6z-h";
export var typingPill = "_6z-g";
export var xl = "_6z-7";
export var xs = "_6z-3";
export var xxl = "_6z-8";
export var xxs = "_6z-2";
export var yellow = "_6z-e";